import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { patientBackendEndPointToken } from '../app.config';
import { DisableCache, LoadingUIEnabled } from '../loading.interceptor';
import {
  MarkNotificationOpenedRequest,
  MarkNotificationReadRequest,
  MarkNotificationResponse,
  MessagingCounts,
  NotificationListFilters,
  NotificationListResponse
} from './messaging.models';

@Injectable({ providedIn: 'root' })
export class MessagingNotificationsService {
  private readonly http = inject(HttpClient);
  private readonly backendApi = inject(patientBackendEndPointToken);
  private readonly apiBase = `${this.backendApi.replace(/\/fhir\/?$/, '')}`;

  listNotifications(participantId: string, filters: NotificationListFilters): Observable<NotificationListResponse> {
    let params = new HttpParams().set('organizationId', filters.organizationId);

    const statuses = Array.isArray(filters.status) ? filters.status.filter(Boolean) : [];
    if (statuses.length) {
      params = params.set('status', statuses.join(','));
    }

    return this.http.get<NotificationListResponse>(`${this.apiBase}/users/${participantId}/notifications`, {
      params,
      context: new HttpContext().set(DisableCache, true).set(LoadingUIEnabled, false)
    });
  }

  markOpened(notificationId: string, payload: MarkNotificationOpenedRequest): Observable<MarkNotificationResponse> {
    return this.http.post<MarkNotificationResponse>(`${this.apiBase}/notifications/${notificationId}/opened`, payload, {
      context: new HttpContext().set(DisableCache, true).set(LoadingUIEnabled, false)
    });
  }

  markRead(notificationId: string, payload: MarkNotificationReadRequest): Observable<MarkNotificationResponse> {
    return this.http.post<MarkNotificationResponse>(`${this.apiBase}/notifications/${notificationId}/read`, payload, {
      context: new HttpContext().set(DisableCache, true).set(LoadingUIEnabled, false)
    });
  }

  getCounts(participantId: string, organizationId: string): Observable<MessagingCounts> {
    const params = new HttpParams().set('organizationId', organizationId);

    return this.http.get<MessagingCounts>(`${this.apiBase}/users/${participantId}/counts`, {
      params,
      context: new HttpContext().set(DisableCache, true).set(LoadingUIEnabled, false)
    });
  }
}
